import { Fragment } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { adminRoutes, userRoutes, publicRoutes } from './routes';
import { DefaultLayout } from './Components/Layout';
import React from 'react';
import { useSelector } from "react-redux";

function App() {
  const currentUser = useSelector((state) => state.auth.login.currentUser);

  const renderRoutes = (routes) => {
    return routes.map((route, index) => {
      const Page = route.component;
      let Layout = DefaultLayout;

      if (route.layout) {
        Layout = route.layout;
      } else if (route.layout === null) {
        Layout = Fragment;
      }

      return (
        <Route
          key={index}
          path={route.path}
          element={
            <Layout>
              <Page />
            </Layout>
          }
        />
      );
    });
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          {publicRoutes.map((route, index) => {
            const Page = route.component;
            let Layout = DefaultLayout;

            if (route.layout) {
              Layout = route.layout;
            } else if (route.layout === null) {
              Layout = Fragment;
            }

            return (
              <Route
                key={index}
                path={route.path}
                element={
                  currentUser && (route.path === "/login" || route.path === "/register") ? (
                    <Navigate to="/" />
                  ) : (
                    <Layout>
                      <Page />
                    </Layout>
                  )
                }
              />
            );
          })}

          {/* Private routes */}
          {currentUser ? (
            <>
              {/* Admin routes */}
              {currentUser.admin === true
                ? renderRoutes(adminRoutes)
                : <Route path="/admin/*" element={<Navigate to="/user" />} />
              }

              {/* User routes */}
              {currentUser.admin !== true
                ? renderRoutes(userRoutes)
                : <Route path="/user/*" element={<Navigate to="/admin" />} />
              }
            </>
          ) : (
            // Nếu chưa đăng nhập, điều hướng về login
            <Route path="*" element={<Navigate to="/login" />} />
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
